import { GzTextAnimationWebComponent } from './component/GzTextAnimationWebComponent';

export { GzTextAnimationWebComponent };
